import { Navigate, Route, Routes } from 'react-router-dom'
import DatTokenUsage from './DatTokenUsage'

export default function DatTokenUsageRoutes() {
    return (
        <Routes>
            <Route index element={<DatTokenUsage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
